/**
 * Deduction Article Number Mapping for V2 Invoice System
 * Maps article numbers to deduction types for editing/copying invoices
 */

export type DeductionType =
  | 'mileage_report'
  | 'allowance_in_sweden'
  | 'allowance_outside_sweden'
  | 'travel_expenses_pdf'
  | 'expenses_materials_tools_pdf';

/**
 * Article Number to Deduction Type Mapping
 * Used when converting copied invoice data to deduction types
 */
export const ARTICLE_NUMBER_TO_DEDUCTION_TYPE: Record<string, DeductionType> = {
  '91': 'travel_expenses_pdf',         // Travel Expenses
  '93': 'mileage_report',              // Mileage Report
  '98': 'travel_expenses_pdf',         // Travel Expenses (duplicate)
  '99': 'expenses_materials_tools_pdf', // Materials & Tools
  '100': 'allowance_outside_sweden',   // Allowance Outside Sweden
  '101': 'allowance_in_sweden',        // Allowance In Sweden
};

/**
 * Get deduction type from article number
 * @param articleNumber - The article number from the invoice
 * @returns Deduction type or default 'mileage_report'
 */
export const getDeductionTypeFromArticleNumber = (articleNumber: string): DeductionType => {
  return ARTICLE_NUMBER_TO_DEDUCTION_TYPE[articleNumber] || 'mileage_report';
};

/**
 * Check if an article number is a valid deduction article
 * @param articleNumber - The article number to check
 * @returns True if it's a valid deduction article number
 */
export const isValidDeductionArticleNumber = (articleNumber: string): boolean => {
  return articleNumber in ARTICLE_NUMBER_TO_DEDUCTION_TYPE;
};

/**
 * Get all valid deduction article numbers
 * @returns Array of valid article numbers
 */
export const getValidDeductionArticleNumbers = (): string[] => {
  return Object.keys(ARTICLE_NUMBER_TO_DEDUCTION_TYPE);
};
